import { type UnityRichText } from '@@api/utils/schemas/schemas';
import { type UnityElement } from '@@plate/serialization/unity/groups';

const unwrapSerializedState = (state: UnityRichText): UnityElement[] =>
    state != null ? state.richTextFormat : state;

export default unwrapSerializedState;
